import type { MarkNotificationAsDelivered200BasicInfo } from './markNotificationAsDelivered200BasicInfo';
import type { MarkNotificationAsDelivered200Data } from './markNotificationAsDelivered200Data';
import type { MarkNotificationAsDelivered200Source } from './markNotificationAsDelivered200Source';
import type { MarkNotificationAsDelivered200Status } from './markNotificationAsDelivered200Status';
import type { MarkNotificationAsDelivered200Target } from './markNotificationAsDelivered200Target';

export type MarkNotificationAsDelivered200 = {
  basicInfo: MarkNotificationAsDelivered200BasicInfo;
  /** @nullable */
  data?: MarkNotificationAsDelivered200Data;
  source?: MarkNotificationAsDelivered200Source;
  status: MarkNotificationAsDelivered200Status;
  target?: MarkNotificationAsDelivered200Target;
};
